export const getUserInfo = state => state.user
export const getLoadingInfo = state => state.loading
